import { TaskLogType,
// Re-aliased to avoid colliding with `entities/Task`'s legacy `TaskStatus` (genie/asa task).
TaskStatus as IndividualTaskStatus } from '../../clients/IndividualTaskClient/generated/IndividualTaskClient/types';
import { isValidBase } from '../BaseEntity';
export { IndividualTaskStatus, TaskLogType };
export const isValidIndividualTask = properties => {
  return isValidBase(properties);
};
//# sourceMappingURL=IndividualTask.js.map